import { injectable } from 'inversify';

import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IEventBusService } from '@/app-modules/event-bus/event-bus-service';
import { ITrackedWinner, IWinnersTrackerService } from '@/components/game/_domain/modules/winners-tracker-service';

import { IFrameGameClickedEventName, IFrameGameLoadedEventName } from '@/components/iframe-game/_domain/models';

export interface IDefaultIFrameMethods {
    getMethods: () => IIFrameMethods;
}

export interface IIFrameMethods {
    onLoaded: () => Promise<void>;
    getConstants: () => Promise<any>;
    onWinner: (data: any) => Promise<void>;
    onClick: (frameId: string) => Promise<void>;
}

@injectable()
export class DefaultIFrameMethods implements IDefaultIFrameMethods {
    public getMethods(): IIFrameMethods {
        return {
            onLoaded: this.onLoaded,
            getConstants: this.getConstants,
            onWinner: this.onWinner,
            onClick: this.onClick
        };
    }

    protected async onLoaded(): Promise<void> {
        const eventBus = container.get(SERVICE_IDENTIFIERS.IEventBusService) as IEventBusService;
        eventBus.getEventBus().$emit(IFrameGameLoadedEventName);
    }

    protected async getConstants(): Promise<any> {
        // TODO: Add required constants here
        return {};
    }

    protected async onWinner(data: ITrackedWinner[]): Promise<void> {
        const winnersTrackerService = container.get(SERVICE_IDENTIFIERS.IWinnersTrackerService) as IWinnersTrackerService;
        winnersTrackerService.trackWinners(...data);
    }

    protected async onClick(frameId: string): Promise<void> {
      const eventBus = container.get(SERVICE_IDENTIFIERS.IEventBusService) as IEventBusService;
      eventBus.getEventBus().$emit(IFrameGameClickedEventName, frameId);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/iframes/default-methods.ts